import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'hdi-bubble',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './bubble.component.html',
  styleUrl: './bubble.component.scss',
  host: {
    id: crypto.randomUUID().toString(),
  },
})
export class BubbleComponent {
  @Input() label?: string;
}
